import script from "./AdminCsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminCsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__